<template>
  <div class="page_editResume">
    <Htitle :title="type + '简历'"></Htitle>

    <div class="resume_box">
      <div class="form_field" ref="name_brief">
        <p class="form_field_label neccess_icon">姓名：</p>
        <div class="pos_input">
          <input type="text" class="form_value_input" placeholder="请填写姓名" v-model.trim="basicQuery.StrUserName">
        </div>
      </div>
      <div class="form_field" ref="phone_brief">
        <p class="form_field_label neccess_icon">联系方式：</p>
        <div class="pos_input">
          <input type="number" class="form_value_input" :class="$route.query.ResumeId || $route.query.mobile ? 'disabled' : ''" placeholder="请填写联系方式" v-model.trim="basicQuery.StrMobile" :disabled="$route.query.ResumeId || $route.query.mobile">
        </div>
      </div>

      <div class="form_field" ref="age">
        <p class="form_field_label">年龄：</p>
        <div class="pos_input">
          <input type="number" class="form_value_input" placeholder="请填写年龄" v-model.trim="basicQuery.StrUserAge">
        </div>
      </div>

      <div class="form_field" ref="sex">
        <p class="form_field_label">性别：</p>
        <div class="pos_input" @click="showSexSelect = true">
          <div class="arrow_selecter">
            <i class="arrow_selecter_icon"></i>
          </div>
          <div class="selecterInput">{{basicQuery.BolUserSex}}
            <span v-if="!basicQuery.BolUserSex">请选择性别</span>
          </div>
        </div>
      </div>

      <div class="form_field">
        <p class="form_field_label">文化程度：</p>
        <div class="pos_input" @click="diplomaSeleter = true">
          <div class="arrow_selecter">
            <i class="arrow_selecter_icon"></i>
          </div>
          <div class="selecterInput">{{basicQuery.StrEduLvl}}
            <span v-if="!basicQuery.StrEduLvl">请选择文化程度</span>
          </div>
        </div>
      </div>

      <div class="form_field">
        <p class="form_field_label">期望薪资：</p>
        <div class="salaryContainer">
          <div class="salaryItem">
            <input class="month" type="number" placeholder="" v-model="basicQuery.salary1" />
            <span class="salary_degree">元</span>
          </div>
          <p class="salary_caret">—</p>
          <div class="salaryItem">
            <input class="month" type="number" placeholder="" v-model="basicQuery.salary2" />
            <span class="salary_degree">元 </span>
          </div>
        </div>
      </div>

      <div class="form_field">
        <p class="form_field_label">意向岗位：</p>

        <div class="pos_input" @click="showPostSelect = true">
          <div class="arrow_selecter">
            <i class="arrow_selecter_icon"></i>
          </div>
          <div class="selecterInput">{{basicQuery.StrJobInf}}
            <span v-if="!basicQuery.StrJobInf">请选择岗位</span>
          </div>
        </div>
      </div>

      <!-- <div class="form_field">
        <p class="form_field_label">求职意向:：</p>
        <div class="pos_input" @click="showIntention = true">
          <div class="arrow_selecter">
            <i class="arrow_selecter_icon"></i>
          </div>
          <div class="selecterInput">{{basicQuery.StrUserJobhunt}}
            <span v-if="!basicQuery.StrUserJobhunt">请选择求职意向</span>
          </div>
        </div>
      </div> -->

      <div class="form_field">
        <p class="form_field_label">居住地：</p>
        <div class="pos_input">
          <input type="text" class="form_value_input" placeholder="请填写居住地" v-model.trim="basicQuery.StrUserAdd" />
        </div>
      </div>

      <div class="save">
        <van-button type="primary" block @click="saveHandle">保存</van-button>
      </div>

    </div>

    <van-popup v-model="showSexSelect" position="bottom">
      <van-picker title="选择性别" show-toolbar :columns="sexList" @confirm="onConfirmSex" @cancel="showSexSelect = false" />
    </van-popup>
    <!--文化程度要求-->
    <van-popup v-model="diplomaSeleter" position="bottom" :style="{ height: '50%' }">
      <van-picker title="选择文化程度" show-toolbar :columns="eduList" @confirm="onConfirmEducation" @cancel="diplomaSeleter = false" />
    </van-popup>

    <!-- 选择岗位 -->
    <van-popup v-model="showPostSelect" position="bottom">
      <div class="pick_btn_box">
        <van-button size="small" type="default" @click="showPostPop" style="margin-right:20px;">关闭</van-button>
        <van-button size="small" type="info" @click="showPostPop">确定</van-button>
      </div>
      <van-cascader class="cascadePost" :show-header="false" :closeable="false" v-model="basicQuery.StrJobInf" :options="intendedPost" @change="onPostChange" :field-names="postFieldName" />
    </van-popup>

    <!--求职意向-->
    <van-popup v-model="showIntention" position="bottom" :style="{ height: '50%' }">
      <van-picker title="选择求职意向" show-toolbar :columns="intentionList" @confirm="onConfirmIntention" @cancel="showIntention = false" />
    </van-popup>

  </div>
</template>
    
<script>
import Htitle from "./components/header.vue";
import xz from "@/common";
export default {
  components: {
    Htitle
  },
  data() {
    return {
      type: '',
      diplomaSeleter: false,
      showSexSelect:false,
      // 文化程度选项
      eduList: [],
      //岗位选项
      intendedPost: [],
      sexList: ['男', '女', '不限'],//性别列表
      intentionList: ["在找工作", "有工作考虑新机会", "不找工作", "未知"],
      // 岗位props
      postFieldName: {
        text: 'strParametername',
        value: 'strParametername',
        children: 'children'
      },
      //选择岗位弹窗
      showPostSelect: false,
      //选择求职意向弹窗
      showIntention: false,
      ResumeId: '',
      // 录入简历参数
      basicQuery: {
        natureId: '', //自然人ID
        ResumeId: 0, //简历ID
        StrUserName: '', //姓名
        StrMobile: '', //联系方式
        StrWorkState: '', //在离职状态
        BolUserSex: '', //性别
        StrUserAge: '', //年龄
        StrNativePlace: '', //户籍
        StrEduLvl: '', //文化程度
        StrJobInf: '', //意向岗位
        StrCategoryIds: '', //意向岗位id
        // 选中的意向岗位
        posCategoryList: [],
        StrUserCity: '', //求职城市
        StrUserAdd: '', //居住地
        StrUserCityCode: '', //求职城市code
        StrSource: '', //来源
        StrUserExpectSa: '', //期望薪资
        salary1: '',
        salary2: '',
        StrRemark: '', //备注
        StrlateCompany: '', //最近入职项目
        DtlateInducDate: '', //最近入职时间
        DtlatequitDate: '', //最近离职时间
        StrquitReason: '', //离职原因
        StrUserJobhunt: '', //求职意向
        StrPsnIsType: 0, //是否公海 1 公海 0私人
        enterUser: '', //录入人
        enterDate: '', //录入时间
        StrJobType: '', //岗位类型
        StrState: '', //状态
        DtupdateDate: '',//最新更新时间
        //拓展
        StrIsBlack: '', //是否黑名单
        StrBlackReason: '', //黑名单原因
        StrUsernation: '', //民族
        Strskill: '', //技能
        Strcertificate: '', //证书
        StrAccomreq: '', //住宿要求
        StrDinreq: '', //吃饭要求
        StrIsqwfri: '', //是否企微好友
        StrCont1: '', //拓展1
        StrCont2: '',
        StrCont3: '',
        StrCont4: '',
        StrCont5: '',
        StrCont6: '',
        StrCont7: '',
        StrCont8: '',
        StrCont9: '',
        StrCont10: '',
        Strsocial: '',//社保需求
        Strother: '', // 政治面貌
        WorkingShift: '', // 班次
        Workingposition: '' // 站班/坐班
      },
    }
  },
  async created() {
    this.$store.commit('setHiddenLeft', true)
    if (this.$route.query.type) {
      this.type = this.$route.query.type
      this.ResumeId = this.$route.query.ResumeId
    }
    if (this.$route.query.ResumeId) {
      this.ResumeId = this.$route.query.ResumeId;
      this.getResumeDtl(this.ResumeId)
    }
    if (this.$route.query.mobile) {
      this.basicQuery.StrMobile = this.$route.query.mobile;
    }
    this.getTreestr();
    this.getdictdatalistbyid();
  },
  methods: {
    // 选择文化程度
    onConfirmEducation(v) {
      this.basicQuery.StrEduLvl = v;
      this.diplomaSeleter = false;
    },
    getdictdatalistbyid() {
      xz.getdictdatalistbyid(141).then(res => {
        if (res.status == 'ok') {
          res.data.retList.forEach(element => {
            this.eduList.push(element.Name)
          })
        }
      })
    },
    //获取岗位
    getTreestr() {
      let data = {
        currpage: 1,
        perpage: 1000,
        strIsDisable: '',
        keyword: ''
      }
      xz.getTreestr('JB_base_Jobcategory', data).then(res => {
        if (res) {
          this.intendedPost = res.msg.parent;
        } else {
          this.intendedPost = [];
        }
      })
    },
    showPostPop() {
      this.showPostSelect = !this.showPostSelect
    },
    //选择性别
    onConfirmSex(v) {
      this.basicQuery.BolUserSex = v;
      this.showSexSelect = false;
    },
    //选择岗位
    onPostChange(e) {
      if (e) {
        this.basicQuery.StrJobInf = e.value;
        this.basicQuery.StrCategoryIds = e.selectedOptions[e.selectedOptions.length - 1].strParameterid
      }
      console.log(e, this.basicQuery.StrCategoryIds)
    },
    // 选择求职意向
    onConfirmIntention(v) {
      this.basicQuery.StrUserJobhunt = v;
      this.showIntention = false;
    },
    // 获取简历详情
    getResumeDtl(ResumeId) {
      this.resumeInfo = {};
      xz.getResumeDetail({ ResumeId: ResumeId }).then(res => {
        if (res.status == 'ok') {
          let resMsg = res.msg
          let resMsgp = res.msgp
          this.basicQuery = {
            natureId: resMsgp.GdPsnId, //自然人ID GdPsnId
            enterUser: resMsgp.Creator, // 录入人
            ResumeId: resMsg.ResumeId, //简历ID
            StrUserName: resMsg.StrUserName, //姓名
            StrMobile: resMsg.StrMobile, //联系方式
            StrWorkState: resMsg.StrWorkState, //在离职状态
            BolUserSex: resMsg.BolUserSex, //性别
            StrUserAge: resMsg.StrUserAge, //年龄
            StrNativePlace: resMsg.StrNativePlace, //户籍
            StrEduLvl: resMsg.StrEduLvl, //文化程度
            StrJobInf: resMsg.StrJobInf, //意向岗位
            StrCategoryIds: resMsg.StrCategoryIds, //意向岗位id
            // 选中的意向岗位
            posCategoryList: [],
            StrUserCity: resMsg.StrUserCity, //求职城市
            StrUserAdd: resMsg.StrUserAdd, //居住地
            StrUserCityCode: resMsg.StrUserCityCode, //求职城市code
            StrSource: resMsg.StrSource, //来源
            StrUserExpectSa: resMsg.StrUserExpectSa, //期望薪资
            salary1: !this.isNull(resMsg.StrUserExpectSa) ? resMsg.StrUserExpectSa.split('-')[0] : '',
            salary2: !this.isNull(resMsg.StrUserExpectSa) ? resMsg.StrUserExpectSa.split('-')[1] : '',
            StrRemark: resMsg.StrRemark, //备注
            StrlateCompany: resMsg.StrlateCompany, //最近入职项目
            DtlateInducDate: !this.isNull(resMsg.DtlateInducDate) ? resMsg.DtlateInducDate : '', //最近入职时间
            DtlatequitDate: !this.isNull(resMsg.DtlatequitDate) ? resMsg.DtlatequitDate : '', //最近离职时间
            StrquitReason: resMsg.StrquitReason, //离职原因
            StrUserJobhunt: resMsg.StrUserJobhunt, //求职意向
            StrPsnIsType: resMsg.StrPsnIsType, //是否公海 1 公海 0私人
            enterDate: resMsg.DtInsertDate, //录入时间
            StrJobType: resMsg.StrJobType, //岗位类型
            StrState: resMsg.StrState, //状态
            DtupdateDate: resMsg.DtupdateDate,
            //拓展
            StrIsBlack: !this.isNull(resMsgp) && !this.isNull(resMsgp.StrIsBlack) ? resMsgp.StrIsBlack : '', //是否黑名单
            StrBlackReason: !this.isNull(resMsgp) && !this.isNull(resMsgp.StrBlackReason) ? resMsgp.StrBlackReason : '', //黑名单原因
            StrUsernation: !this.isNull(resMsgp) && !this.isNull(resMsgp.StrUsernation) ? resMsgp.StrUsernation : '', //民族
            Strskill: !this.isNull(resMsgp) && !this.isNull(resMsgp.Strskill) ? resMsgp.Strskill : '', //技能
            Strcertificate: !this.isNull(resMsgp) && !this.isNull(resMsgp.Strcertificate) ? resMsgp.Strcertificate : '', //证书
            StrAccomreq: !this.isNull(resMsgp) && !this.isNull(resMsgp.StrAccomreq) ? resMsgp.StrAccomreq : '', //住宿要求
            StrDinreq: !this.isNull(resMsgp) && !this.isNull(resMsgp.StrDinreq) ? resMsgp.StrDinreq : '', //吃饭要求
            StrIsqwfri: !this.isNull(resMsgp) && !this.isNull(resMsgp.StrIsqwfri) ? resMsgp.StrIsqwfri : '', //是否企微好友
            StrCont1: !this.isNull(resMsgp) && !this.isNull(resMsgp.StrCont1) ? resMsgp.StrCont1 : '', //拓展1
            StrCont2: !this.isNull(resMsgp) && !this.isNull(resMsgp.StrCont2) ? resMsgp.StrCont2 : '',
            StrCont3: !this.isNull(resMsgp) && !this.isNull(resMsgp.StrCont3) ? resMsgp.StrCont3 : '',
            StrCont4: !this.isNull(resMsgp) && !this.isNull(resMsgp.StrCont4) ? resMsgp.StrCont4 : '',
            StrCont5: !this.isNull(resMsgp) && !this.isNull(resMsgp.StrCont5) ? resMsgp.StrCont5 : '',
            StrCont6: !this.isNull(resMsgp) && !this.isNull(resMsgp.StrCont6) ? resMsgp.StrCont6 : '',
            StrCont7: !this.isNull(resMsgp) && !this.isNull(resMsgp.StrCont7) ? resMsgp.StrCont7 : '',
            StrCont8: !this.isNull(resMsgp) && !this.isNull(resMsgp.StrCont8) ? resMsgp.StrCont8 : '',
            StrCont9: !this.isNull(resMsgp) && !this.isNull(resMsgp.StrCont9) ? resMsgp.StrCont9 : '',
            StrCont10: !this.isNull(resMsgp) && !this.isNull(resMsgp.StrCont10) ? resMsgp.StrCont10 : '',
            Strsocial: resMsgp.Strsocial,//社保需求
            Strother: resMsgp.Strother, // 政治面貌
            WorkingShift: resMsgp.WorkingShift, // 班次
            Workingposition: resMsgp.Workingposition // 站班/坐班
          }
        } else {
          this.$toast.fail('获取用户简历出错')
        }
      });
    },
    saveHandle() {
      if (!this.basicQuery.StrUserName) {
        this.$toast('请填写姓名')
        return
      } else if (!this.basicQuery.StrMobile) {
        this.$toast('请填写联系方式')
        return
      } else if(this.basicQuery.StrMobile.length!=11){
        this.$toast('请填写正确的手机号码')
        return
      }
      if (this.basicQuery.posCategoryList) {
        this.basicQuery.StrCategoryIds = this.basicQuery.posCategoryList.toString()
      }
      this.basicQuery.StrUserExpectSa = this.basicQuery.salary1 + '-' + this.basicQuery.salary2;
      xz.saveResumeinfo(this.basicQuery, [], [], []).then(res => {
        // console.log('saveEnterHandle', res)
        if (res.status == 'ok') {
          this.$toast.success('保存成功')
          setTimeout(() => {
            this.$router.go(-1);
          }, 2000)
        } else {
          this.$toast.fail('系统出错')
        }
      })
    },
    //判断是否为空(包含0)
    isNull(o) {
      return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 0 || o == 'NaN' || o == ('1900-01-01') || o == '1900-01-01T00:00:00';
    }
  }
}

  </script>
 <style scoped>
.page_editResume {
  background: #fff;
  min-height: 100vh;
}
.form_field {
  /**表单填写项容器宽度**/
  width: 90%;
  margin: 0 auto 20px auto;
  align-items: flex-start;
  flex-wrap: wrap;
  border-bottom: 1px solid #ccc;
}
.form_field_label {
  /**表单字段名**/
  font-size: 13px;
  color: #333;
  line-height: 28px;
}
.neccess_icon::after {
  /**字段名必填标志**/
  content: "*";
  color: #da2824;
  margin-left: 5px;
  font-size: 16px;
}
.pos_input {
  position: relative;
}
.form_value_input {
  /**表单填写项input样式**/
  width: 100%;
  border: 1px solid rgba(46, 69, 139, 0.2);
  height: 40px;
  border-style: none;
  margin-bottom: 10px;
  background: #fff;
  font-size: 14px;
  line-height: 40px;
  outline: none;
  box-shadow: none;
  box-sizing: border-box;
  padding: 0 10px;
  border-radius: 5px;
}
.error_border {
  border: 1px dashed #c82a2e !important;
}
.error_text {
  margin-top: 5px;
  color: #c82a2e;
  font-size: 14px;
  display: block;
  width: 100%;
  margin-left: 0;
}
.page_editResume .neccess_icon::after {
  display: none;
}
.page_editResume .neccess_icon::before {
  content: "*";
  color: #da2824;
  margin-right: 2px;
  font-size: 16px;
}
.seleteContainer {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}
.salaryItem {
  font-size: 16px;
}
.salaryContainer {
  width: 100%;
  display: flex;
  align-items: center;
}
.salaryContainer .salaryItem {
  position: relative;
  width: 100%;
}
.salaryContainer .salaryItem input {
  width: 100%;
  height: 40px;
  padding: 0 10px;
  box-sizing: border-box;
}
.salary_degree {
  position: absolute;
  right: 10px;
  top: 0;
  line-height: 40px;
  color: #353535;
  font-size: 15px;
}
input {
  border-style: none;
  height: 22px;
  font-size: 16px;
  padding: 5px 0 10px 10px;
}

.arrow_selecter {
  position: absolute;
  top: 0;
  right: 0;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.arrow_selecter_icon {
  display: block;
  width: 14px;
  height: 8px;
  background: url("../../assets/images/selecter_icon.png") no-repeat;
  background-size: 100% auto;
}
.selecterInput {
  width: 100%;
  height: 40px;
  border-radius: 5px;
  border: 1px solid rgba(46, 69, 139, 0.2);
  box-sizing: border-box;
  padding: 0 10px;
  line-height: 40px;
  color: #353535;
  font-size: 15px;
  border-style: none;
  margin-bottom: 10px;
}
.selecterInput span {
  font-size: 14px;
  color: #757575;
}
.pick_btn_box {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
  padding: 0 20px;
}

.save {
  width: 90%;
  margin: 0 auto;
  padding: 10px 0 20px;
}
.disabled{
  background:#c3c3c3;
}
</style>
    
 